import Footer from '../Components/Footer';
import NewTopic from '../Components/ForumComp/NewTopic';
import Header from '../Components/Header';

function NewTopicPage() {

    return (
        <div>
            <Header/>
            <NewTopic/>
            <Footer/>
        </div>
    );
}

export default NewTopicPage;